import React from 'react'

import { Flex, Link, Text, UserAvatar } from '@driftt/dds'

import { ContactWithActivites } from 'modules/accountActivity/domain'
import { getEndUserDisplayLocation } from 'utils/endUser'
import { contactPath } from 'utils/paths'

export const ContactTile = ({
  contact,
  trackAction,
  isAvailable
}: {
  contact: ContactWithActivites
  trackAction: (action: string) => void
  isAvailable?: boolean
}) => {
  return (
    <Flex>
      <UserAvatar
        imageUrl={contact.endUserData.avatarUrl}
        name={contact.endUserData.name}
        size="small"
        status={isAvailable === undefined ? undefined : isAvailable ? 'available' : 'away'}
      />
      <Flex direction="column" gap={0}>
        <Link
          variant="inline"
          onClick={() => {
            window.open(contactPath(contact.endUserId), '_blank')
            trackAction('Open contact page')
          }}>
          {contact.endUserData.name || contact.endUserData.email || 'Site Visitor'}
        </Link>
        {contact.endUserData.role && <Text>{contact.endUserData.role}</Text>}
        <Text>
          {getEndUserDisplayLocation(
            contact.endUserData.locationCity,
            contact.endUserData.locationStateCode ?? contact.endUserData.locationState,
            contact.endUserData.locationCountryCode ?? contact.endUserData.locationCountry
          )}
        </Text>
      </Flex>
    </Flex>
  )
}
